module.exports = __webpack_public_path__ + "img/img10.2fdbc8e9.png";